
import { getNavigationList, getCategoryList,getConfigData } from "@/request/api";

const state = {
    navigationList: [],
    categoryList: [],
    categoryObj: {},
    footData:{},
    configData:{},
}

const mutations = {
    SET_NAV(state, data) {
        state.navigationList = data
    },
    SET_CATEGORY(state, data) {
        state.categoryList = data || {};
    },
    SET_CATEGORY_OBJ(state, data) {
        state.categoryObj = data
    },

    SET_FOOT(state, data) {
        state.footData = data
    },
    SET_CONFIG(state, data) {
        state.configData = data
    },

}

const actions = {
    GenerateNav({ commit,dispatch }) {
        return new Promise(resolve => {
            // 向后端请求路由数据
            getNavigationList().then(res => {
                let list = res.data || [];
                if (res.code == 200) {
                    if (res.data != null && res.data.length > 0) {

                        let fndata = function (data) {
                            data.forEach((item) => {
                                if (item.pageContent) {
                                    item.pageContent = JSON.parse(item.pageContent);
                                }
                                if (item.subnavigation && item.subnavigation.length) {
                                    fndata(item.subnavigation);
                                }
                            });
                            return data;
                        };
                        list = fndata(list);
                        commit('SET_NAV', list)
                        dispatch('GenerateCategory').then(ress=>{})                       
                        resolve(list)
                    }
                }
            })
        })
    },
    GenerateCategory({ commit,state }) {
        return new Promise(resolve => {
            getCategoryList().then((res) => {
                if (res.data) {
                    commit('SET_CATEGORY', res.data);
                    let fndata = function (data,obj={}) {
                        data.forEach((item) => {
                            obj[item.id]=item;
                            if (item.subcategories && item.subcategories.length) {
                                fndata(item.subcategories,obj);
                            }
                        });
                        return obj;
                    };
                    commit('SET_CATEGORY_OBJ', fndata(res.data));
                    let list = state.navigationList;
                    if (list.length > 0) {
                        let findIndex = list.findIndex(item => item.pageContent && item.pageContent.pageType == "class");
                        if (findIndex >= 0) {
                            let subnavigation = res.data.map(item => {
                                return { navigationName: item.categoryName, pageContent: { pageType: "custom", linkUrl: "/category/list/" + item.id } }
                            })
                            list[findIndex].subnavigation=subnavigation;
                            commit('SET_NAV', list)
                        }
                    }

                }
                resolve(res.data)
            });
        })

    },

    GenerateFooter({ commit }) {
        return new Promise(resolve => {
            // 向后端请求路由数据
            getConfigData().then(res => {
                if (res.code == 200 && res.data) {
                    let data= JSON.parse(res.data.pageJson);
                    const images = require.context('@/assets/images', true, /\.png$/i); 
                    let fnImg=function(url){
                        if(url.includes("static/img/")){
                            let name=url.split("/").pop();
                            name=name.split(".")
                            return images("./"+name[0]+"."+name[name.length-1]);
                        }
                        return url
                    }
                    data.pageList.downloadCodeUrl1=fnImg(data.pageList.downloadCodeUrl1)
                    data.pageList.downloadCodeUrl2=fnImg(data.pageList.downloadCodeUrl2)

                    data.pageList.footOfficial.forEach(item=>{
                        item.popList && item.popList.forEach(child=>{
                            child.imgUrl=fnImg(child.imgUrl)
                        })
                    })
                

                    commit('SET_FOOT', data.pageList)
                    
                    data.config.logo1= data.config.logo1 && data.config.logo1.includes("assets/images/logo")?"":data.config.logo1;
                    data.config.logo2= data.config.logo2 && data.config.logo2.includes("assets/images/logo")?"":data.config.logo2;
                    commit('SET_CONFIG', data.config)
                }
                resolve(res.data)
            })
        })
    },



}

const getters = {

}

export default {
    state,
    mutations,
    actions,
    getters
}